// extracted by mini-css-extract-plugin
export default {"product_select":"GPCRvxfnc9ccwNFV6IYL"};